import { useState, useEffect } from 'react';
import { WifiOff, RefreshCw, CheckCircle2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export const ConnectionStatus = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [isSyncing, setIsSyncing] = useState(false);
    const [showSynced, setShowSynced] = useState(false);
    
    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            setIsSyncing(true);
            // Simular sync ou esperar o resumePausedMutations
            setTimeout(() => {
                setIsSyncing(false);
                setShowSynced(true);
                setTimeout(() => setShowSynced(false), 3000);
            }, 2000);
        };

        const handleOffline = () => {
            setIsOnline(false);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (isOnline && !isSyncing && !showSynced) return null;

    return (
        <div className={cn(
            "fixed bottom-4 right-4 z-50 flex items-center gap-3 px-4 py-2 rounded-full border shadow-lg transition-all duration-500 animate-in slide-in-from-bottom-5",
            !isOnline ? "bg-red-50 border-red-200 text-red-700" : 
            isSyncing ? "bg-blue-50 border-blue-200 text-blue-700" :
            "bg-emerald-50 border-emerald-200 text-emerald-700"
        )}>
            {isSyncing ? (
                <RefreshCw className="w-4 h-4 animate-spin" />
            ) : !isOnline ? (
                <WifiOff className="w-4 h-4" />
            ) : (
                <CheckCircle2 className="w-4 h-4" />
            )}
            
            <span className="text-sm font-medium">
                {!isOnline ? "Você está offline. Alterações serão salvas localmente." : 
                 isSyncing ? "Sincronizando dados..." : 
                 "Tudo sincronizado!"}
            </span>
            
            {!isOnline && (
                <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse ml-1" />
            )}
        </div>
    );
};
